// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__7pRaf","title":"AfterFrontImage_title__7vuoh"};